// Platform yetenek tablosu: "Olustur" ekraninin TEK dogruluk kaynagi.
//
// NEDEN tek bir sabit: ekran hem platforma ozel secenek bolumlerini hem de
// "yayinlanabilir mi" kararini BURADAN uretiyor. Yeni bir platform (TikTok,
// LinkedIn, X...) gercekten yayinlanabilir hale geldiginde buraya tek bir
// kayit eklemek yetiyor; arayuz kendiliginden buyuyor. Tersi de gecerli:
// burada olmayan platform arayuzde HIC gorunmez.
//
// Sunucuda ayni liste OmnupIcerikController::PLATFORMLAR icinde duruyor ve
// hesap kutucuklari SUNUCUDAN geliyor (GET icerik/hesaplar). Yani buradaki
// kayitlar yalnizca sunucunun bildirdigi platformlar icin kullaniliyor; iki
// liste ayrissa bile arayuz olmayan bir platform cizmez.
//
// DURUM alani, secenek basina uc degerden biri:
//   'acik'    -> secenek gercekten calisiyor.
//   'yakinda' -> arka uc (OmnupYayinServisi) HENUZ desteklemiyor. Secenek
//                gorunur ama KAPALI ve sebebi yazili. Tiklandiginda hicbir sey
//                yapmayan bir kutucuk, olmayan ozelligi varmis gibi
//                gostermektir; kullanicinin gonderisi sessizce yanlis cikar.
//   'gizli'   -> hic cizilmez. Emin olmadigimiz, kullaniciya anlatacak bir
//                sozumuz de olmayan secenekler icin.
//
// Arka uc bir secenegi destekler hale geldiginde yapilacak TEK sey burada
// 'yakinda' degerini 'acik' yapmak.
//
// Platform ADI ve SIMGESI burada TEKRARLANMIYOR: onlar tum Icerik ekranlarinin
// ortak sabitlerinde (icerik-ortak.js) duruyor. Ayni platformun listede baska,
// Olustur ekraninda baska gorunmesi, iki ayri liste tutmanin kacinilmaz sonucu
// olurdu.
import { PLATFORM_ANAHTARLARI, PLATFORM_SIMGELERI } from './icerik-ortak';

export const DURUM_ACIK = 'acik';
export const DURUM_YAKINDA = 'yakinda';
export const DURUM_GIZLI = 'gizli';

// Bir gonderiye eklenebilecek azami medya.
//
// NEDEN 1: OmnupYayinServisi#tek_medya birden fazla medyayi (carousel)
// acikca reddediyor - Instagram carousel'i ayri bir is_carousel_item akisi
// istiyor. Kullaniciya ikinci gorseli sectirip yayin aninda hata vermek,
// sectirmemekten kotudur. Arka uc carousel'i destekledigi gun burasi
// degisecek tek satir.
export const AZAMI_MEDYA = 1;

// Gonderi metni siniri. Sunucu da dogruluyor; buradaki sayac kullanicinin
// metni YAZARKEN gormesi icin. Instagram basligi 2200, Facebook gonderisi
// 63206 karakterde kesiliyor.
const INSTAGRAM_SINIRI = 2200;
const FACEBOOK_SINIRI = 63206;

export const PLATFORMLAR = {
  instagram: {
    ad: 'instagram',
    anahtar: PLATFORM_ANAHTARLARI.instagram,
    simge: PLATFORM_SIMGELERI.instagram,
    renk: 'text-n-ruby-11',
    metinSiniri: INSTAGRAM_SINIRI,
    // Instagram metin tek basina kabul etmiyor: her gonderi bir gorsel ya da
    // video tasimak zorunda.
    medyaZorunlu: true,
    secenekler: [
      {
        ad: 'icerik_turu',
        tur: 'secim',
        durum: DURUM_ACIK,
        anahtar: 'ICERIK.OLUSTUR.IG_TUR',
        varsayilan: 'gonderi',
        degerler: [
          {
            deger: 'gonderi',
            durum: DURUM_ACIK,
            anahtar: 'ICERIK.OLUSTUR.IG_TUR_GONDERI',
            // Kural arka uctan geliyor: normal gonderi kabinda video
            // gonderilemiyor (OmnupYayinServisi#instagram_kap_govdesi).
            medyaTuru: 'gorsel',
          },
          {
            deger: 'reel',
            durum: DURUM_ACIK,
            anahtar: 'ICERIK.OLUSTUR.IG_TUR_REEL',
            medyaTuru: 'video',
          },
          {
            deger: 'story',
            durum: DURUM_ACIK,
            anahtar: 'ICERIK.OLUSTUR.IG_TUR_STORY',
            // Hikaye hem gorsel hem video kabul ediyor.
            medyaTuru: null,
            // Meta hikaye kabinda caption almiyor; metin yayinlanmaz.
            // Kullaniciya ONCEDEN soylemezsek "yazdigim metin nerede"
            // sorusuyla geri doner.
            uyari: 'ICERIK.OLUSTUR.UYARI_STORY_METIN',
          },
        ],
      },
      {
        ad: 'ilk_yorum',
        tur: 'metin',
        durum: DURUM_ACIK,
        cokSatirli: true,
        sinir: INSTAGRAM_SINIRI,
        anahtar: 'ICERIK.OLUSTUR.IG_ILK_YORUM',
        yer: 'ICERIK.OLUSTUR.IG_ILK_YORUM_YER',
        // Ayri bir izin kapsami (instagram_business_manage_comments) gerekiyor;
        // gonderi yayinlanir ama yorum eklenemezse hedefin notunda gorunur.
        not: 'ICERIK.OLUSTUR.IG_ILK_YORUM_NOT',
      },
      {
        ad: 'konum_id',
        tur: 'dugme',
        durum: DURUM_YAKINDA,
        anahtar: 'ICERIK.OLUSTUR.IG_KONUM',
        sebep: 'ICERIK.OLUSTUR.IG_KONUM_SEBEP',
      },
      {
        ad: 'etiketler',
        tur: 'dugme',
        durum: DURUM_YAKINDA,
        anahtar: 'ICERIK.OLUSTUR.IG_ETIKET',
        sebep: 'ICERIK.OLUSTUR.IG_ETIKET_SEBEP',
      },
      {
        ad: 'ortak_gonderi',
        tur: 'dugme',
        durum: DURUM_YAKINDA,
        anahtar: 'ICERIK.OLUSTUR.IG_ORTAK',
        sebep: 'ICERIK.OLUSTUR.IG_ORTAK_SEBEP',
      },
    ],
  },

  facebook: {
    ad: 'facebook',
    anahtar: PLATFORM_ANAHTARLARI.facebook,
    simge: PLATFORM_SIMGELERI.facebook,
    renk: 'text-n-blue-11',
    metinSiniri: FACEBOOK_SINIRI,
    // Facebook sayfasi yalnizca metinle de gonderi kabul ediyor.
    medyaZorunlu: false,
    secenekler: [
      {
        // Sayfa SECIMI yukaridaki hesap kutucuklarinda yapiliyor. Burada
        // ikinci bir secici koymak iki ayri dogruluk kaynagi olurdu; secilmis
        // sayfalari yalnizca GOSTERIYORUZ ki kullanici hangi sayfaya gittigini
        // secenekleri ayarlarken de gorsun.
        ad: 'sayfa',
        tur: 'hesap_listesi',
        durum: DURUM_ACIK,
        anahtar: 'ICERIK.OLUSTUR.FB_SAYFA',
        not: 'ICERIK.OLUSTUR.FB_SAYFA_NOT',
      },
      {
        ad: 'hedef_kitle',
        tur: 'liste',
        durum: DURUM_ACIK,
        anahtar: 'ICERIK.OLUSTUR.FB_KITLE',
        varsayilan: 'herkes',
        degerler: [
          {
            deger: 'herkes',
            durum: DURUM_ACIK,
            anahtar: 'ICERIK.OLUSTUR.FB_KITLE_HERKES',
          },
          {
            deger: 'daraltilmis',
            durum: DURUM_YAKINDA,
            anahtar: 'ICERIK.OLUSTUR.FB_KITLE_DARALTILMIS',
            sebep: 'ICERIK.OLUSTUR.FB_KITLE_SEBEP',
          },
        ],
      },
      {
        ad: 'baglanti',
        tur: 'metin',
        durum: DURUM_ACIK,
        cokSatirli: false,
        anahtar: 'ICERIK.OLUSTUR.FB_BAGLANTI',
        yer: 'ICERIK.OLUSTUR.FB_BAGLANTI_YER',
        // Medyali gonderi /photos ucundan gidiyor ve o uc link almiyor:
        // baglanti yalnizca medyasiz gonderide islenir. Medya varken notu
        // vurguluyoruz - girilen adres o an sessizce yok sayilacak demektir.
        not: 'ICERIK.OLUSTUR.FB_BAGLANTI_NOT',
        notVurgusu: 'medya_varsa',
      },
      {
        ad: 'reel',
        tur: 'dugme',
        durum: DURUM_YAKINDA,
        anahtar: 'ICERIK.OLUSTUR.FB_REEL',
        sebep: 'ICERIK.OLUSTUR.FB_REEL_SEBEP',
      },
    ],
  },
};

// Sunucudan gelen platform adini tabloya cevirir. Tanimadigimiz bir ad
// gelirse null doneriz; cagiran o hesabi cizmez.
export const platformKurali = ad => PLATFORMLAR[String(ad || '')] || null;

// Platformun kendi ayar kutusundaki varsayilanlar.
// Kullanici hic dokunmasa bile gonderide anlamli bir ayar dursun.
export const varsayilanAyar = platformAd => {
  const kural = platformKurali(platformAd);
  if (!kural) return {};

  const ayar = {};
  kural.secenekler.forEach(secenek => {
    if (secenek.varsayilan !== undefined) ayar[secenek.ad] = secenek.varsayilan;
  });
  return ayar;
};

// Secili platformlarin en DAR metin siniri. Iki hesaba ayni metin gidiyor;
// kullanicinin gormesi gereken sinir en kucuk olandir.
export const metinSiniri = platformlar => {
  const kurallar = platformlar.map(platformKurali).filter(Boolean);
  if (!kurallar.length) return null;

  return kurallar.reduce(
    (dar, kural) => (kural.metinSiniri < dar.metinSiniri ? kural : dar),
    kurallar[0]
  );
};

// Secim listesinden bir degerin tanimini bulur.
const degerTanimi = (kural, secenekAdi, deger) => {
  const secenek = kural?.secenekler.find(s => s.ad === secenekAdi);
  return secenek?.degerler?.find(d => d.deger === deger) || null;
};

// --- Yayin engelleri -------------------------------------------------------
//
// Arka ucun (OmnupYayinServisi) reddedecegi durumlari YAYINDAN ONCE soyleriz.
// NEDEN burada tekrar: sunucu zaten dogruluyor ama hatayi ancak Meta'ya
// gidilip donuldukten sonra veriyor. Kullanicinin "Yayinla" dugmesine basip
// beklemesi, sonra "Reel icin video gerekli" cevabini almasi, dugmeyi en
// bastan kapali gostermekten kotudur.
//
// Her engel { anahtar, veri } doner: metin i18n'de, sayilar veride. Burasi
// arayuz metni tutmaz.
export const yayinEngelleri = ({ platformlar, metin, medya, secenekler }) => {
  const engeller = [];
  const yazi = String(metin || '');
  const dosyalar = medya || [];
  const ilk = dosyalar[0] || null;

  if (!platformlar.length) {
    engeller.push({ anahtar: 'ICERIK.OLUSTUR.ENGEL_HESAP_YOK', veri: {} });
  }

  if (!yazi.trim() && !dosyalar.length) {
    engeller.push({ anahtar: 'ICERIK.OLUSTUR.ENGEL_BOS', veri: {} });
  }

  if (dosyalar.length > AZAMI_MEDYA) {
    engeller.push({
      anahtar: 'ICERIK.OLUSTUR.ENGEL_COK_MEDYA',
      veri: { sayi: AZAMI_MEDYA },
    });
  }

  const sinir = metinSiniri(platformlar);
  if (sinir && yazi.length > sinir.metinSiniri) {
    engeller.push({
      anahtar: 'ICERIK.OLUSTUR.ENGEL_METIN_UZUN',
      veri: { sinir: sinir.metinSiniri, platform: sinir.anahtar },
    });
  }

  if (platformlar.includes('instagram')) {
    const ayar = secenekler.instagram || {};
    const tur = ayar.icerik_turu || 'gonderi';
    const tanim = degerTanimi(PLATFORMLAR.instagram, 'icerik_turu', tur);

    if (!ilk) {
      engeller.push({ anahtar: 'ICERIK.OLUSTUR.ENGEL_IG_MEDYA', veri: {} });
    } else if (tanim?.medyaTuru && ilk.tur !== tanim.medyaTuru) {
      engeller.push({
        anahtar:
          tanim.medyaTuru === 'video'
            ? 'ICERIK.OLUSTUR.ENGEL_IG_REEL_VIDEO'
            : 'ICERIK.OLUSTUR.ENGEL_IG_GONDERI_GORSEL',
        veri: {},
      });
    }
  }

  // Facebook sayfasina video /videos ucundan parcali yukleme istiyor; servis
  // bunu acikca reddediyor.
  if (platformlar.includes('facebook') && ilk && ilk.tur === 'video') {
    engeller.push({ anahtar: 'ICERIK.OLUSTUR.ENGEL_FB_VIDEO', veri: {} });
  }

  return engeller;
};

// --- Uyarilar --------------------------------------------------------------
//
// Yayini ENGELLEMEYEN ama sonucu degistiren durumlar. Gonderi cikar, sadece
// kullanicinin bekledigi gibi cikmaz; sessiz kalmak onu sasirtir.
export const yayinUyarilari = ({ platformlar, medya, secenekler }) => {
  const uyarilar = [];
  const ilk = (medya || [])[0] || null;

  if (platformlar.includes('instagram')) {
    const tur = secenekler.instagram?.icerik_turu || 'gonderi';
    const tanim = degerTanimi(PLATFORMLAR.instagram, 'icerik_turu', tur);
    if (tanim?.uyari) uyarilar.push({ anahtar: tanim.uyari, veri: {} });
  }

  if (platformlar.includes('facebook')) {
    const baglanti = String(secenekler.facebook?.baglanti || '').trim();
    if (baglanti && ilk) {
      uyarilar.push({
        anahtar: 'ICERIK.OLUSTUR.UYARI_FB_BAGLANTI_MEDYA',
        veri: {},
      });
    }
  }

  return uyarilar;
};
